window.Upsell = {
    upSellIds: [],
    currency: shop.moneyFormat.replace("{" + "{amount}" + "}", ""),
    upSellSelector: $(".Upsell-Selector"),
    start: function () {
        var self = this;
        /*this.upSellSelector.on("change", function () {
            var option = $(this).find("option[value='"+$(this).val()+"']");
            var upSellPrice = option.data("price") || 0;
            var productPrice = self._parsePrice($(".current_price").text());
            $("[data-product-price-new]").text(self._getPrice(upSellPrice + productPrice));
            //var newInstalmentPrice = (upSellPrice + productPrice)/4;
            //newInstalmentPrice = self._getPrice(newInst.jsalmentPrice) + " " + shop.currency;
            //$(".afterpay-instalments").text(newInstalmentPrice);
        });*/

        $(document).ready(function () {
            self.reRender();
        });
    },
    refresh: function (oldItems, newItems) {
        var upSellId;
        var updates = {};
        var changes = [];
        if (!this._validate(newItems)) {
            var upSells = {};
            for (var i = 0; i < newItems.length; i++) {
                upSellId = this._getUpSellId(newItems[i]);
                if (upSellId) {
                    if (!this.upSellIds.includes(upSellId)) {
                        //                         this.upSellIds.push(upSellId);
                        upSells[upSellId] = newItems[i].quantity;
                    } else {
                        upSells[upSellId] = upSells[upSellId] + newItems[i].quantity;
                    }
                } else {
                    if (this._shouldRemove(newItems[i], oldItems, newItems)) {
                        updates[newItems[i].id] = 0;
                    } else {
                        var parentItems = this._getParentProducts(newItems[i].variant_id, newItems);
                        if (parentItems.length > 0) {
                            updates[newItems[i].id] = parentItems[0].quantity;
                        }
                    }
                }
            }
            updates = this._mergeObjs(updates, upSells);
        } else {
            var decreasedItems = this._decreasedItems(oldItems, newItems);
            if (decreasedItems.length) {
                for (var j = 0; j < decreasedItems.length; j++) {
                    var item = decreasedItems[j];
                    var decreasedAmount = this._getQty(item.id, oldItems) - this._getQty(item.id, newItems);
                    if (decreasedAmount === this._getQty(item.id, oldItems)) {
                        upSellId = this._getUpSellId(item);
                        if (upSellId && this._getVariantQty(upSellId, newItems) != this._getQty(item.id, newItems)) {
                            var newQty = this._getVariantQty(upSellId, newItems) - decreasedAmount;
                            if (!changes[upSellId]) {
                                changes[upSellId] = newQty;
                            }

                        }
                    }
                }
            }

            for (var x = 0; x < newItems.length; x++) {
                var xItem = newItems[x];
                if (this.upSellIds.includes(xItem.id.toString()) && !this._getParentProducts(xItem.id, newItems).length) {
                    updates[xItem.id] = 0;
                }
            }
        }
        if (_.keys(updates).length) {

            var self = this;

            CartJS.updateItemQuantitiesById(updates, {
                success: function (cart) {
                    self.reRender(cart);
                }
            });
        }
    },
    reRender: function (cart) {
        if (typeof cart === "undefined") {
            cart = shop.cart;
        }
        if (typeof cart.item_count != 'undefined') {
            var item_count = cart.item_count;
            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                var upSellId = this._getUpSellId(item);
                var deliveryId = this._getDeliveryId(item);
                if (upSellId) {
                    var upSellItem = this._getItem(upSellId, cart.items);
                    item_count -= upSellItem.quantity;
                    // Popup when first load
                    if (typeof deliveryId != 'undefined') {
                        var parentElem = $("#popupcart-item-" + item.id + "[data-upsell='" + upSellId + "_" + deliveryId + "']");
                    } else {
                        var parentElem = $("#popupcart-item-" + item.id + "[data-upsell='" + upSellId + "_']");
                    }
                    if (!upSellItem) {
                        parentElem.addClass('undefined');
                    }
                    $("#popupcart-item-" + upSellItem.id + "[_isupsell]").hide().addClass('has-upsell');
                    parentElem.find(".item-title").text(item.product_title + " + " + upSellItem.product_title);
                    var priceElem = parentElem.find(".item-price");
                    var qty = Number(parentElem.find(".item-qty").first().text());
                    priceElem.text(this._getPrice((item.price + upSellItem.price) * qty / 100));


                    // Cart page
                    if (typeof deliveryId != 'undefined') {
                        var parentElemCart = $("#cart-item-" + item.id + "[data-upsell='" + upSellId + "_" + deliveryId + "']");
                    } else {
                        var parentElemCart = $("#cart-item-" + item.id + "[data-upsell='" + upSellId + "_']");
                    }
                    $("#cart-item-" + upSellItem.id + "[_isupsell]").hide().addClass('has-upsell');
                    parentElemCart.find(".product_title").text(item.product_title + " + " + upSellItem.product_title);
                    var priceElemCart = parentElemCart.find(".item-price");
                    var priceTotalElemCart = parentElemCart.find(".item-total-price strong");
                    var qtyCart = Number(parentElemCart.find(".cart_quantity").val());
                    priceElemCart.text(this._getPrice((item.price + upSellItem.price) / 100));
                    priceTotalElemCart.text(this._getPrice((item.price + upSellItem.price) * qtyCart / 100));
                }
            }
        } else {
            var item_count = cart.cart.item_count;
            for (var i = 0; i < cart.cart.items.length; i++) {
                var item = cart.cart.items[i];
                var upSellId = this._getUpSellId(item);
                var deliveryId = this._getDeliveryId(item);
                if (upSellId) {
                    var upSellItem = this._getItem(upSellId, cart.cart.items);
                    item_count -= upSellItem.quantity;

                    // Popup after card updated
                    if (typeof deliveryId != 'undefined') {
                        var parentElem = $("#popupcart-item-" + item.id + "[data-upsell='" + upSellId + "_" + deliveryId + "']");
                    } else {
                        var parentElem = $("#popupcart-item-" + item.id + "[data-upsell='" + upSellId + "_']");
                    }
                    if (!upSellItem) {
                        parentElem.addClass('undefined');
                    }
                    $("#popupcart-item-" + upSellItem.id + "[_isupsell]").hide().addClass('has-upsell');
                    parentElem.find(".item-title").text(item.product_title + " + " + upSellItem.product_title);
                    var priceElem = parentElem.find(".item-price");
                    var qty = Number(parentElem.find(".item-qty").first().text());
                    priceElem.text(this._getPrice((item.price + upSellItem.price) * qty / 100));

                    // Cart page
                    if (typeof deliveryId != 'undefined') {
                        var parentElemCart = $("#cart-item-" + item.id + "[data-upsell='" + upSellId + "_" + deliveryId + "']");
                    } else {
                        var parentElemCart = $("#cart-item-" + item.id + "[data-upsell='" + upSellId + "_']");
                    }
                    $("#cart-item-" + upSellItem.id + "[_isupsell]").hide().addClass('has-upsell');
                    parentElemCart.find(".product_title").text(item.product_title + " + " + upSellItem.product_title);
                    var priceElemCart = parentElemCart.find(".item-price");
                    var priceTotalElemCart = parentElemCart.find(".item-total-price strong");
                    var qtyCart = Number(parentElemCart.find(".cart_quantity").val());
                    priceElemCart.text(this._getPrice((item.price + upSellItem.price) / 100));
                    priceTotalElemCart.text(this._getPrice((item.price + upSellItem.price) * qtyCart / 100));
                }
            }
        }
        $("#CartItemCount").text(item_count);
    },
    hasMulti: function (id, items) {
        var count = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].id == id) {
                count++;
            }
        }
        return count > 1;
    },
    add: function (line, qty) {
        jQuery.ajax({
            type: 'POST',
            async: "false",
            url: '/cart/change.js',
            data: { line: line, quantity: qty },
            dataType: 'json'
        });
    },
    _countTotal: function (upSellId) {
        var total = 0;
        var cartItems = shop.cart.line_items;
        if (!cartItems.length) return total;
        for (var i = 0; i < cartItems.length; i++) {
            var item = cartItems[i];

        }
    },
    _getItem: function (variant_id, items) {
        var result = false;
        for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id == variant_id) {
                result = items[i];
            }
        }
        return result;
    },
    _getVariantQty: function (variantId, items) {
        var result = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id == variantId) {
                result += items[i].quantity;
            }
        }
        return result;
    },
    _decreasedItems: function (oldItems, newItems) {
        var result = [];
        if (!oldItems.length) {
            return [];
        }

        for (var i = 0; i < newItems.length; i++) {
            if (this._getQty(newItems[i].id, newItems) < this._getQty(newItems[i].id, oldItems)) {
                result.push(newItems[i]);
            }
        }
        return result;
    },
    _getQty: function (id, items) {
        var result = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].id == id) {
                result += items[i].quantity;
            }
        }
        return result;
    },
    _mergeObjs: function (obj1, obj2) {
        var obj3 = {};
        for (var attr in obj1) { obj3[attr] = obj1[attr]; }
        for (var attr in obj2) { obj3[attr] = obj2[attr]; }
        return obj3;
    },
    _getHasUpSellItems: function (items) {
        var result = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.properties && item.properties.ID && item.properties.ID !== "") {
                result.push(item);
            }
        }
        return result;
    },
    _getParentProducts: function (upSellId, items) {
        var result = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.properties && item.properties.ID && item.properties.ID == upSellId) {
                result.push(item);
            }
        }
        return result;
    },
    _getUpSellId: function (item) {

        if (item.properties && item.properties.ID !== "") {
            return item.properties.ID;
        }
        return false;
    },
    _getDeliveryId: function (item) {
        if (item.properties && item.properties._Delivery_Date !== "") {
            return item.properties._Delivery_Date;
        }
        return false;
    },
    _shouldRemove: function (item, oldItems, newItems) {
        if (this._getUpSellId(item)) {
            return false;
        }

        if (!oldItems || !this._itemExist(item, oldItems)) {
            return false;
        }

        var oldParentIds = this._getParentProducts(item.variant_id, oldItems);
        if (oldParentIds.length === 0) {
            return false;
        }

        var isParentStillExist = false;
        for (var i = 0; i < oldParentIds.length; i++) {
            if (this._itemExist(oldParentIds[i], newItems)) {
                isParentStillExist = true;
                break;
            }
        }
        if (isParentStillExist) {
            return false;
        }

        return true;

    },
    _itemExist: function (checkItem, items) {
        var result = false;
        for (var i = 0; i < items.length; i++) {
            if (checkItem.id === items[i].id) {
                result = true;
                break;
            }
        }
        return result;
    },
    _parsePrice: function (priceString) {
        return parseFloat(priceString.replace(this.currency, ""))
    },
    _getPrice: function (price) {
        return '$' + price.toFixed(0).toString();
    },
    _validate: function (items) {
        var result = true;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.properties && item.properties.ID) {
                if (this._countNeededItems(items, item.properties.ID) !== this._countUpSell(items, item.properties.ID)) {
                    result = false;
                    break;
                }
            }
        }
        return result;
    },
    _countUpSell: function (items, upsellId) {
        var result = 0;
        for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id == upsellId) {
                result += items[i].quantity;
            }
        }
        return result;
    },
    _countNeededItems: function (items, upsellId) {
        var result = 0;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.properties && item.properties.ID && item.properties.ID == upsellId) {
                result += item.quantity;
            }
        }
        return result;

    }
}

window.Upsell.start();
